import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nestedProperty'
})
export class NestedPropertyPipe implements PipeTransform {
  transform(context: Record<string, unknown>, nestedField: string): string {
    const nestedProperties: string[] = nestedField.split('.');
    let value: any = context;
    for (const prop of nestedProperties) {
      if (value) {
        value = value[prop];
      } else {
        break;
      }
    }
    return value;
  }
}
